import { render, staticRenderFns } from "./FarmsBrowse.vue?vue&type=template&id=231e9850&scoped=true"
import script from "./FarmsBrowse.vue?vue&type=script&lang=js"
export * from "./FarmsBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231e9850",
  null
  
)

export default component.exports